import React, { useState, useEffect } from 'react';
import { db, auth } from '../../firebase';
import { ref, onValue } from 'firebase/database';
import { useNavigate } from 'react-router-dom';
import InchargeLayout from './InchargeLayout';
import {
    FaSearch,
    FaAddressCard,
    FaUserCircle,
    FaTrashAlt,
    FaCopy,
    FaFileExcel,
    FaPrint,
    FaChevronRight,
    FaArrowLeft
} from 'react-icons/fa';

const ViewSocietyForm = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [registrations, setRegistrations] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            if (!user) navigate('/login');
        });

        const registrationsRef = ref(db, 'ekamwatapzp/SocietyRegistrations');
        const unsubData = onValue(registrationsRef, (snapshot) => {
            let list = [];
            if (snapshot.exists()) {
                const dataObj = snapshot.val();
                list = Object.keys(dataObj).map(key => ({
                    id: key,
                    ...dataObj[key]
                }));
            }

            // Add Dummy Data for testing if list is empty or for demonstration
            const dummyData = [
                {
                    id: 'dummy1',
                    societyName: 'जय भवानी मजूर सहकारी संस्था मर्या.',
                    societyAddress: 'कल्याण (प), सांगली',
                    regDistrict: 'सांगली',
                    registrarType: 'उपनिबंधक',
                    registrationDate: '12-05-2022',
                    taluka: 'कल्याण',
                    chairmanWhatsapp: '9876543210',
                    submittedAt: Date.now() - 86400000,
                    assistantStatus: 'pending',
                    chairmanName: 'संजय राजाराम पवार'
                },
                {
                    id: 'dummy2',
                    societyName: 'आदर्श विकास मजूर सहकारी संस्था',
                    societyAddress: 'मानपाडा रोड, डोंबिवली',
                    regDistrict: 'सांगली',
                    registrarType: 'सहाय्यक उपनिबंधक',
                    registrationDate: '20-08-2021',
                    taluka: 'भिवंडी',
                    chairmanWhatsapp: '9988776655',
                    submittedAt: Date.now() - 172800000,
                    assistantStatus: 'pending',
                    chairmanName: 'राजेश विनायक साळुंके'
                },
                {
                    id: 'dummy3',
                    societyName: 'एकता ग्रामीण विकास संस्था',
                    societyAddress: 'शहापूर, जिल्हा सांगली',
                    regDistrict: 'सांगली',
                    registrarType: 'उपनिबंधक',
                    registrationDate: '05-01-2023',
                    taluka: 'शहापूर',
                    chairmanWhatsapp: '9123456789',
                    submittedAt: Date.now() - 259200000,
                    assistantStatus: 'rejected',
                    chairmanName: 'विजय लक्ष्मण जाधव'
                },
                {
                    id: 'dummy4',
                    societyName: 'साई समर्थ मजूर सहकारी संस्था',
                    societyAddress: 'अंबरनाथ (पू), सांगली',
                    regDistrict: 'सांगली',
                    registrarType: 'सहाय्यक उपनिबंधक',
                    registrationDate: '15-11-2022',
                    taluka: 'अंबरनाथ',
                    chairmanWhatsapp: '9000011122',
                    submittedAt: Date.now() - 345600000,
                    assistantStatus: 'pending',
                    chairmanName: 'अमित दत्तात्रेय काटकर'
                },
                {
                    id: 'dummy5',
                    societyName: 'जनसेवा मजूर सहकारी मंडळ',
                    societyAddress: 'मुरबाड, सांगली',
                    regDistrict: 'सांगली',
                    registrarType: 'उपनिबंधक',
                    registrationDate: '30-03-2022',
                    taluka: 'मुरबाड',
                    chairmanWhatsapp: '8877665544',
                    submittedAt: Date.now() - 432000000,
                    assistantStatus: 'pending',
                    chairmanName: 'प्रकाश बाळकृष्ण मोरे'
                }
            ];

            const combinedList = [...list, ...dummyData];
            setRegistrations(combinedList.sort((a, b) => (b.submittedAt || 0) - (a.submittedAt || 0)));
            setLoading(false);
        });

        return () => {
            unsubscribe();
            unsubData();
        };
    }, [navigate]);

    const filteredData = registrations.filter(item => {
        // Only show users who are NOT yet Assistant Approved in this "New" list
        const status = (item.assistantStatus || '').toLowerCase();
        if (status === 'approved' || status === 'accepted') return false;

        const name = (item.societyName || '').toLowerCase();
        const phone = (item.chairmanWhatsapp || '').toString();
        return name.includes(searchTerm.toLowerCase()) || phone.includes(searchTerm);
    });

    const formatDate = (timestamp) => {
        if (!timestamp) return 'N/A';
        const date = new Date(timestamp);
        return date.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        });
    };

    const StatusBadge = ({ status }) => {
        const statusLower = (status || 'pending').toLowerCase();
        let colorClass = 'text-amber-500 bg-amber-50/50 border-amber-100/50';
        let text = 'Pending';

        if (statusLower === 'accepted' || statusLower === 'approved') {
            colorClass = 'text-green-600 bg-green-50/50 border-green-100/50';
            text = 'Approved';
        } else if (statusLower === 'rejected') {
            colorClass = 'text-red-600 bg-red-50/50 border-red-100/50';
            text = 'Rejected';
        }

        return (
            <span className={`font-bold text-[10px] uppercase tracking-tighter px-2.5 py-1.5 rounded-lg border ${colorClass}`}>
                {text}
            </span>
        );
    };

    return (
        <InchargeLayout>
            <div className="min-h-screen bg-[#f8fafc] p-4 md:p-8 text-gray-800">
                {/* Header & Breadcrumb */}
                <div className="flex flex-col md:flex-row md:items-center justify-between mb-10 gap-4">
                    <div className="flex items-center gap-4">
                        <button
                            onClick={() => navigate(-1)}
                            className="p-2.5 bg-white border border-gray-200 rounded-xl text-gray-500 hover:text-blue-600 hover:border-blue-100 hover:bg-blue-50 transition-all shadow-sm group"
                        >
                            <FaArrowLeft size={16} className="group-hover:-translate-x-1 transition-transform" />
                        </button>
                        <div>
                            <h1 className="text-2xl font-bold text-gray-800 tracking-tight">नवीन मजूर संस्थांची यादी</h1>
                        </div>
                    </div>
                    <div className="flex items-center text-[10px] font-bold tracking-widest text-[#94a3b8] gap-2 uppercase">
                        <span>सांगली जिल्हा परिषद</span>
                        <FaChevronRight size={8} className="text-gray-300" />
                        <span className="text-blue-600">नवीन मजूर संस्थांची यादी</span>
                    </div>
                </div>

                {/* Main Card */}
                <div className="bg-white rounded-2xl shadow-xl shadow-gray-200/50 border border-gray-100 overflow-hidden">

                    {/* Legend Section */}
                    <div className="px-8 pt-8 flex flex-col lg:flex-row justify-end items-center gap-10">
                        <div className="flex items-center gap-6">
                            <div className="flex items-center gap-2">
                                <div className="w-3 h-3 rounded-full bg-amber-500 shadow-sm shadow-amber-200"></div>
                                <span className="text-[10px] font-bold text-gray-500 tracking-tight uppercase">प्रलंबित</span>
                            </div>
                            <div className="flex items-center gap-2">
                                <div className="w-3 h-3 rounded-full bg-green-600 shadow-sm shadow-green-200"></div>
                                <span className="text-[10px] font-bold text-gray-500 tracking-tight uppercase">मंजूर</span>
                            </div>
                            <div className="flex items-center gap-2">
                                <div className="w-3 h-3 rounded-full bg-red-600 shadow-sm shadow-red-200"></div>
                                <span className="text-[10px] font-bold text-gray-500 tracking-tight uppercase">नाकारले</span>
                            </div>
                        </div>
                        <div className="flex flex-wrap items-center gap-5 text-[9px] font-bold text-gray-400 uppercase tracking-widest">
                            <div className="flex items-center gap-2"><FaAddressCard className="text-[#334155] text-sm" /> संस्थेची माहिती</div>
                            <div className="flex items-center gap-2"><FaUserCircle className="text-[#334155] text-sm" /> संस्थेची कागदपत्रे</div>
                            <div className="flex items-center gap-2"><FaTrashAlt className="text-gray-300 text-sm hover:text-red-500 transition-colors" /> डिलीट</div>
                        </div>
                    </div>

                    {/* Toolbar */}
                    <div className="p-8 flex flex-col md:flex-row justify-between items-center gap-8 border-b border-gray-50">
                        <div className="flex items-center gap-1">
                            <button className="flex items-center gap-2 px-6 py-2 bg-[#64748b] text-white rounded text-[11px] font-bold hover:bg-slate-700 transition active:scale-95 shadow-lg shadow-slate-100 uppercase tracking-widest">
                                <FaCopy size={12} /> Copy
                            </button>
                            <button className="flex items-center gap-2 px-6 py-2 bg-[#64748b] text-white rounded text-[11px] font-bold hover:bg-slate-700 transition active:scale-95 shadow-lg shadow-slate-100 uppercase tracking-widest">
                                <FaFileExcel size={12} /> Excel
                            </button>
                            <button className="flex items-center gap-2 px-6 py-2 bg-[#64748b] text-white rounded text-[11px] font-bold hover:bg-slate-700 transition active:scale-95 shadow-lg shadow-slate-100 uppercase tracking-widest">
                                <FaPrint size={12} /> Print
                            </button>
                        </div>
                        <div className="flex items-center gap-3">
                            <label className="text-[11px] font-bold text-gray-400 uppercase tracking-widest">Search:</label>
                            <input
                                type="text"
                                className="border border-gray-200 rounded-lg px-4 py-2 text-xs font-bold focus:outline-none focus:ring-4 focus:ring-blue-500/10 focus:border-blue-500 transition-all w-72 md:w-80 shadow-inner bg-gray-50/50"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                    </div>

                    {/* Table Container */}
                    <div className="overflow-x-auto">
                        <table className="w-full text-left border-collapse">
                            <thead>
                                <tr className="bg-[#f8fafc] text-[#94a3b8] uppercase tracking-[0.10em] text-[10px] font-bold border-y border-gray-100">
                                    <th className="px-5 py-6 border-r border-gray-50 text-center w-12">क्र. ↑↓</th>
                                    <th className="px-6 py-6 border-r border-gray-50 text-left min-w-[300px]">संस्थेचे नाव ↑↓</th>
                                    <th className="px-6 py-6 border-r border-gray-50 text-center">फोन क्र. ↑↓</th>
                                    <th className="px-6 py-6 border-r border-gray-50 text-center">नोंदणी दिनांक ↑↓</th>
                                    <th className="px-6 py-6 border-r border-gray-50 text-center">Assistant Status ↑↓</th>
                                    <th className="px-6 py-6 border-r border-gray-50 text-center">Accountant Status ↑↓</th>
                                    <th className="px-6 py-6 border-r border-gray-50 text-center">Deputy Eng. Status ↑↓</th>
                                    <th className="px-6 py-6 border-r border-gray-50 text-center text-nowrap">Engineer Status ↑↓</th>
                                    <th className="px-6 py-6 border-r border-gray-50 text-center text-nowrap">Add CEO Status ↑↓</th>
                                    <th className="px-6 py-6 border-r border-gray-50 text-center text-nowrap">CEO Status ↑↓</th>
                                    <th className="px-6 py-6 text-center">Action ↑↓</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-50">
                                {loading ? (
                                    <tr>
                                        <td colSpan="11" className="px-6 py-12 text-center text-gray-300 font-bold tracking-widest animate-pulse uppercase italic">लोड होत आहे...</td>
                                    </tr>
                                ) : (
                                    filteredData.map((item, index) => (
                                        <tr key={item.id} className="hover:bg-blue-50/40 transition-all border-b border-gray-50 group">
                                            <td className="px-5 py-8 border-r border-gray-50 text-center font-bold text-gray-400 text-xs">
                                                {index + 1}
                                            </td>
                                            <td className="px-6 py-8 border-r border-gray-50 font-bold text-gray-700 text-[11px] group-hover:text-blue-700 transition-colors leading-relaxed italic uppercase">
                                                {item.societyName}
                                            </td>
                                            <td className="px-6 py-8 border-r border-gray-50 text-center font-bold text-gray-600 text-[11px] italic">
                                                {item.chairmanWhatsapp}
                                            </td>
                                            <td className="px-6 py-8 border-r border-gray-50 text-center italic">
                                                <div className="flex flex-col text-[10px] font-bold text-gray-600">
                                                    <span>{formatDate(item.submittedAt)}</span>
                                                    <span className="text-gray-400 mt-0.5">{item.submittedAt ? new Date(item.submittedAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : ''}</span>
                                                </div>
                                            </td>
                                            {/* Status Columns */}
                                            <td className="px-6 py-8 border-r border-gray-50 text-center"><StatusBadge status={item.assistantStatus} /></td>
                                            <td className="px-6 py-8 border-r border-gray-50 text-center"><StatusBadge status={item.payments?.["Registration invoice"]?.accountantStatus} /></td>
                                            <td className="px-6 py-8 border-r border-gray-50 text-center"><StatusBadge status={item.deputyEngStatus} /></td>
                                            <td className="px-6 py-8 border-r border-gray-50 text-center"><StatusBadge status={item.engineerStatus} /></td>
                                            <td className="px-6 py-8 border-r border-gray-50 text-center"><StatusBadge status={item.addCeoStatus} /></td>
                                            <td className="px-6 py-8 border-r border-gray-50 text-center"><StatusBadge status={item.ceoStatus} /></td>
                                            <td className="px-6 py-8 text-center">
                                                <div className="flex items-center justify-center gap-3">
                                                    <div
                                                        className="hover:scale-125 transition-transform cursor-pointer"
                                                        onClick={() => navigate('/main-view-society-application-form', { state: { userData: item } })}
                                                        title="तपशील पहा"
                                                    >
                                                        <FaAddressCard className="text-[#334155] text-sm" />
                                                    </div>
                                                    <div
                                                        className="hover:scale-125 transition-transform cursor-pointer"
                                                        onClick={() => navigate('/main-new-society-status', { state: { userData: item } })}
                                                        title="कागदपत्रे पहा"
                                                    >
                                                        <FaUserCircle className="text-[#334155] text-sm" />
                                                    </div>
                                                    <div className="hover:scale-125 transition-transform cursor-pointer"><FaTrashAlt className="text-gray-300 text-sm hover:text-red-500 transition-colors" /></div>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Footer Copyright */}
                <div className="mt-12 text-center pb-8 border-t border-gray-100 pt-8 opacity-40">
                    <p className="text-[10px] font-bold text-gray-400 uppercase tracking-[0.2em] italic">
                        © 2026 Zilla Parishad Thane. All Rights Reserved.
                    </p>
                </div>
            </div>
        </InchargeLayout>
    );
};

export default ViewSocietyForm;
